import _, { get } from 'lodash'
import moment from 'moment'
import { isNaN } from 'lodash'
import { getValueForModeJS } from '../../constants/toUnits'
import { updateTabValueJS } from '../../lib/common'
import { getPreviewDynamicData } from '../../lib/projectAxios'
import { LIST_BASED_FIELDS } from '../../constants/LIST_BASED_FIELDS'
import { getCurrencyFormat, singleNumberFormat } from '../../constants/currencyFormat'
import { TAB_TYPES } from '../../lib/tab-utils'
import { mergeDeep as jsMergeDeep, mergeDeep } from '../../lib/mergeDeep'
import { getFormDateFormat } from '../../lib/format'

export const getPageState = (pageUID, page, pageID, layoutMode = 'lg', customElemId) => {
  let pageState = {}

  let freshState = get(getPreviewDynamicData(), ['freshState'])
  let hashProcessedElements = {}
  const processChildState = (path, elements, isRepeat, allowEmptyRow) => (ret, id) => {
    const el = elements[id]
    let state = {
      ...ret,
    }
    if (hashProcessedElements[id]) {
      return state
    }
    hashProcessedElements[id] = true
    if (el) {
      let tailPath = []
      if (isRepeat && allowEmptyRow) {
        tailPath = [0]
      } else if (isRepeat && !allowEmptyRow) {
        return {}
      }
      let elPath = [...path, id]
      if (el.type === 'titanForm') {
        let url = _.get(freshState, [pageID, id], '')
        if (url) {
          _.set(state, [...elPath, ...tailPath], url)
        }
      } else if (el.type === 'Tracker') {
        let firstOption = _.get(el, ['props', layoutMode, 'options', 0, 'options', 0])
        if (firstOption) {
          _.set(state, [...elPath, ...tailPath, 'ftListValue'], firstOption.id)
          _.set(state, [...elPath, ...tailPath, 'ftListLabel'], firstOption.label)
          _.set(state, [...elPath, ...tailPath, 'ftListFinish'], false)
        }
      } else if (el.type === 'Modal') {
        _.set(state, [...elPath, ...tailPath], true)
      } else if (el.type === 'Ranking') {
        let choices = _.get(el, ['props', 'items'], [])
        if (_.get(el, ['props', 'lg', 'shuffleOptions'])) {
          choices = _.map(_.shuffle(choices), (v, i) => {
            v.order = i
            return v
          })
        }
        choices = _.each(choices, function (row, key) {
          row.order = key + 1
          if (isNaN(row.order)) {
            row.order = key + 1
          }
        })
        choices = _.sortBy(choices, function (row, key) {
          return row.order
        })
        _.each(choices, (row) => {
          _.set(state, [...elPath, ...tailPath, row.uid], row.order)
          _.set(state, [...elPath, ...tailPath, `${row.uid}-value`], row.value)
          _.set(state, [...elPath, ...tailPath, `${row.uid}-label`], row.label)
        })
      } else if (el.type === 'RepeatAutoFit') {
        const allowEmptyRow = get(el, ['props', 'allowEmptyRow'], true)
        let repeatValueState = {}
        if (allowEmptyRow) {
          _.set(repeatValueState, _.compact([_.first(path), id, 'value']), [''])
          _.set(repeatValueState, _.compact([_.first(path), `${id}-totalRows`]), 1)
        } else {
          _.set(repeatValueState, _.compact([_.first(path), id, 'value']), [])
          _.set(repeatValueState, _.compact([_.first(path), `${id}-totalRows`]), 0)
        }
        _.each(_.get(el, ['props', 'params'], []), (param) => {
          if (param.paramType === 'static') {
            _.set(repeatValueState, _.compact([_.first(path), id, param.id]), [param.value ?? ''])
          }
        })
        let childState = _.reduce(
          el.children,
          processChildState(_.compact([_.first(path), id]), elements, true, allowEmptyRow),
          repeatValueState
        )
        if (typeof childState == 'string') {
          childState = {}
        }
        state = mergeDeep(state, childState)
      } else if (el.type === 'DateRange') {
        _.set(
          state,
          [...elPath, 'startDate', ...tailPath],
          getValueForModeJS(el, layoutMode, ['props'], ['startDate'], '')
        )
        _.set(state, [...elPath, 'endDate', ...tailPath], getValueForModeJS(el, layoutMode, ['props'], ['endDate'], ''))
      } else if (el.type === 'CES') {
        if (_.get(el, ['props', 'source'], 'static') === 'static') {
          const items = _.get(el, ['props', 'items'], [])
          let value = _.get(el, ['props', layoutMode, 'value'], '')
          let selected = _.find(items, (item) => item.value === value)
          if (selected) {
            _.set(state, [...elPath, 'ftListLabel', ...tailPath], selected.label)
            _.set(state, [...elPath, 'ftListValue', ...tailPath], selected.value)
          }
        }
      } else if (el.type === 'Range') {
        _.set(state, [...elPath, 'min', ...tailPath], getValueForModeJS(el, layoutMode, ['props'], ['value'], '1'))
        _.set(state, [...elPath, 'max', ...tailPath], getValueForModeJS(el, layoutMode, ['props'], ['valueMax'], '10'))
      } else if (el.type === 'TextCounter') {
        let value = parseInt(getValueForModeJS(el, layoutMode, ['props'], ['value'], '0'), 10)
        let min = getValueForModeJS(el, layoutMode, ['props'], ['minValue'], '')
        let max = getValueForModeJS(el, layoutMode, ['props'], ['maxVal'], '')
        if (min !== '' && Number(min)) {
          min = Number(min)
          value = Math.max(value, min)
        }
        if (max !== '' && Number(max)) {
          max = Number(max)
          value = Math.min(value, max)
        }
        _.set(state, [...elPath, ...tailPath], value)
      } else if (el.type === 'CircleSlider') {
        let value = parseInt(getValueForModeJS(el, layoutMode, ['props'], ['value'], '0'), 10)
        let min = parseInt(getValueForModeJS(el, layoutMode, ['props'], ['minValue'], '0'), 10)
        if (Number.isInteger(min)) {
          value = Math.max(value, min)
        }
        _.set(state, [...elPath, 'value', ...tailPath], value)
      } else if (el.type === 'Rating' || el.type === 'StarRating') {
        _.set(
          state,
          [...elPath, ...tailPath],
          getValueForModeJS(el, layoutMode, ['props'], ['value'], el.type === 'CircleSlider' ? '0' : '')
        )
      } else if (el.type === 'FormField') {
        const control = get(el, 'props.control', 'text')
        if (['text', 'textarea', 'email', 'url', 'number', 'richtextarea'].indexOf(control) !== -1) {
          _.set(state, [...elPath, ...tailPath], getValueForModeJS(el, layoutMode, ['props'], ['value'], ''))
        } else if (['date', 'time', 'datetime'].indexOf(control) !== -1) {
          let useCurrentDate = getValueForModeJS(el, layoutMode, ['props'], ['useCurrentDate'], false)
          let val
          if (useCurrentDate) {
            val = moment(new Date()).format()
          } else {
            val = getValueForModeJS(el, layoutMode, ['props'], ['value'], '')
          }
          try {
            let fieldProps = getValueForModeJS(el, layoutMode, ['props'], [], false)
            let format = getFormDateFormat(fieldProps, control)

            if (control == 'time' || control == 'datetime' || control == 'date') {
              let formatedValue = moment(val).format(format)
              if (val && formatedValue == 'Invalid date') {
                let localVal = moment(moment().format('YYYY-MM-DDT') + val)
                formatedValue = moment(localVal).utc().format(format)
              } else if (formatedValue == 'Invalid date') {
                formatedValue = ''
              }
              _.set(state, [...path, id + '-formattedValue', ...tailPath], formatedValue)
            }
          } catch (err) {
            console.error(err)
          }
          _.set(state, [...elPath, ...tailPath], val)
        } else if (control === 'checkbox' && get(el, ['props', 'source'], 'single') === 'single') {
          _.set(state, [...elPath, ...tailPath], Boolean(getValueForModeJS(el, layoutMode, ['props'], ['value'], '')))
        } else if (LIST_BASED_FIELDS.indexOf(control) !== -1 || control === 'checkbox') {
          if (control === 'radio') {
            let value = {
              ftListValue: getValueForModeJS(el, layoutMode, ['props'], ['value'], ''),
            }
            // _.set(state, [...elPath, 'ftListValue', ...tailPath], getValueForModeJS(el, layoutMode, ['props'], ['value'], ''))
            let itemValue = getValueForModeJS(el, layoutMode, ['props'], ['value'], '')
            let options = _.get(el, ['props', 'items'], [])
            let labelValue = _.find(options, (val) => val.value === itemValue)
            value.ftListLabel = _.get(labelValue, 'label', '')
            _.set(state, [...elPath, ...tailPath], value)
          } else {
            let value = getValueForModeJS(el, layoutMode, ['props'], ['value'], '')
            let options = _.get(el, ['props', 'items'], [])
            _.set(state, [...elPath, 'ftListValue', ...tailPath], value)

            let labels = []
            _.each(String(value).split(';'), (value) => {
              let label = _.find(options, (val) => val.value === value)
              if (label) {
                labels.push(label?.label || '')
              }
            })
            if (labels.length) {
              _.set(state, [...elPath, 'ftListLabel', ...tailPath], labels.join(';'))
            } else {
              let labelValue = _.find(options, (val) => val.value === value)
              if (labelValue) {
                _.set(state, [...elPath, 'ftListLabel', ...tailPath], _.get(labelValue, 'label', ''))
              }
            }
            if (control === 'checkbox') {
              let selectedCount = 0
              if (value) {
                selectedCount = String(value).split(';').length
              }
              _.set(state, [...elPath, 'selectedCount', ...tailPath], selectedCount)
            }
          }
        } else if (control === 'daterange') {
          let startDate = getValueForModeJS(el, layoutMode, ['props'], ['startDate'], '')
          let endDate = getValueForModeJS(el, layoutMode, ['props'], ['endDate'], '')
          let formatedValue = ''
          const format = getFormDateFormat(_.get(el, ['props', layoutMode], {}), 'date')
          let useCurrentDate = getValueForModeJS(el, layoutMode, ['props'], ['useCurrentDate'], false)
          if (useCurrentDate) {
            startDate = new Date()
            formatedValue = moment(startDate).format(format)
            formatedValue += ` - ${formatedValue}`
            _.set(state, [...elPath, ...tailPath, 'startDate'], moment(startDate).format('YYYY-MM-DD'))
            _.set(state, [...elPath, ...tailPath, 'endDate'], moment(startDate).format('YYYY-MM-DD'))
          } else {
            if (startDate) {
              startDate = new Date(startDate)
              if (startDate !== 'Invalid Date') {
                formatedValue = moment(startDate).format(format)
                _.set(state, [...elPath, ...tailPath, 'startDate'], moment(startDate).format('YYYY-MM-DD'))
              }
            }
            if (endDate) {
              endDate = new Date(endDate)
              if (endDate !== 'Invalid Date') {
                if (formatedValue) {
                  formatedValue += ' - '
                }
                formatedValue += moment(endDate).format(format)
                _.set(state, [...elPath, ...tailPath, 'endDate'], moment(endDate).format('YYYY-MM-DD'))
              }
            }
          }
          if (formatedValue) {
            _.set(state, [...path, id + '-formattedValue', ...tailPath], formatedValue)
          }
        } else if (control === 'currency') {
          let format = getCurrencyFormat(_.get(el, 'props.' + layoutMode + '.currencyFormat', ''))

          _.set(state, [...elPath, 'value', ...tailPath], getValueForModeJS(el, layoutMode, ['props'], ['value'], ''))
          if (format && _.isNumber(getValueForModeJS(el, layoutMode, ['props'], ['value'], ''))) {
            _.set(
              state,
              [...elPath, 'formattedValue', ...tailPath],
              singleNumberFormat(getValueForModeJS(el, layoutMode, ['props'], ['value'], ''), format)
            )
          }
        } else if (control !== 'lookup' && control !== 'fileupload') {
          _.set(state, [...elPath, ...tailPath], getValueForModeJS(el, layoutMode, ['props'], ['value'], ''))
        }
      } else if (TAB_TYPES.includes(el.type)) {
        if (_.get(el, 'props.source', '') != 'sf') {
          let value = getValueForModeJS(el, layoutMode, ['props'], ['value'], '')
          if (el.type === 'Accordion' && _.get(el, ['props', layoutMode, 'isCollapseOnLoad'])) {
            value = null
          }
          if (value) {
            let ftIsFirst = false
            let ftIsLast = false
            let tabs = updateTabValueJS(_.filter(_.get(el, ['props', layoutMode, 'tabs'], []), (tab) => !tab?.hide))
            let valueIndex = _.findIndex(tabs, (tab) => tab.ftValue === value)
            if (valueIndex === -1) {
              valueIndex = _.findIndex(tabs, (tab) => tab.id === value)
            }
            if (valueIndex !== -1) {
              value = tabs[valueIndex].ftValue || value
            }
            if (valueIndex === 0) {
              ftIsFirst = true
            }
            if (valueIndex === 0) {
              ftIsFirst = true
            }
            if (_.size(tabs) - 1 === valueIndex) {
              ftIsLast = true
            }
            if (isRepeat && allowEmptyRow && ['Stepper', 'CarouselContainer'].includes(el.type)) {
              _.set(state, [...elPath, ...tailPath, 'ftListValue'], value)
              _.set(state, [...elPath, ...tailPath, 'ftIsFirst'], ftIsFirst)
              _.set(state, [...elPath, ...tailPath, 'ftIsLast'], ftIsLast)
            } else {
              _.set(state, [...elPath, 'ftListValue', ...tailPath], value)
              _.set(state, [...elPath, 'ftIsFirst', ...tailPath], ftIsFirst)
              _.set(state, [...elPath, 'ftIsLast', ...tailPath], ftIsLast)
            }
          }
        }
        const tabs = _.get(el, ['props', 'lg', 'tabs'], [])
        _.each(tabs, (r) => {
          let childState = _.reduce(r.children, processChildState(path, elements, isRepeat, allowEmptyRow), {})
          if (typeof childState == 'string') {
            childState = {}
          }
          state = mergeDeep(state, childState)
        })
      } else if (el.type === 'Section' || el.type === 'Stack' || el.type === 'Scroll') {
        const children = get(el, 'children', [])
        let childState = _.reduce(children, processChildState(path, elements, isRepeat, allowEmptyRow), {})
        state = _.merge(state, childState)
      } else if (el.type === 'PowerTable') {
        // let inputColumns = getPowerTableInputColumnDefaults(fromJS(el))
        // _.each(inputColumns, (value, colId) => {
        //     _.set(state, [...elPath, colId], _.times(100, n => value))
        // })
      } else if (el.type === 'Form') {
        const rows = getValueForModeJS(el, layoutMode, ['props'], ['children'], {})
        _.each(rows, (row) => {
          _.each(row.children, (col) => {
            let childState = _.reduce(col.children, processChildState(path, elements, isRepeat, allowEmptyRow), {})
            state = _.merge(state, childState)
          })
        })
      }
    }
    return state
  }

  if (customElemId) {
    let customState = processChildState([], get(page, ['Settings', 'elements'], {}), false, false)({}, customElemId)
    return customState
  }

  _.each(_.get(page, ['Props', 'Grid'], []), (stripID) => {
    const strip = get(page, ['Props', 'elements', stripID], {})
    const path = [pageUID]
    const isRepeat = get(strip, ['props', 'isRepeat'], false)
    const isRepeatCol = get(strip, ['props', 'isRepeatCol'], false)
    const repeatColName = get(strip, ['props', 'repeatColName'])
    const allowEmptyRow = get(strip, ['props', 'allowEmptyRow'], true)
    const isParentRepeat = isRepeat || (isRepeatCol && repeatColName)
    if (isRepeat || (isRepeatCol && repeatColName)) {
      path.push(stripID)
    }
    let stripState = {}
    if (allowEmptyRow && (isRepeat || isRepeatCol)) {
      _.each(_.get(strip, ['props', 'params'], []), (param) => {
        if (param.paramType === 'static') {
          _.set(stripState, [...path, param.id], [param.value ?? ''])
        }
      })
    }
    const elState = _.reduce(
      strip.children,
      processChildState(path, get(page, ['Props', 'elements'], {}), isParentRepeat, allowEmptyRow),
      stripState
    )
    pageState = jsMergeDeep(pageState, elState)
  })
  return pageState
}
